import { AccountApi, PasswordApi, TrialApi, UserApi } from '../api';

import { BASE_PATH } from './utils/configUtil';

export const accountApi = new AccountApi(undefined, BASE_PATH);
export const userApi = new UserApi(undefined, BASE_PATH);
export const passwordApi = new PasswordApi(undefined, BASE_PATH);
export const trialApi = new TrialApi(undefined, BASE_PATH);
